import React from 'react';
import { PolicyWrapper, PolicyFilter } from '../../../common';
import ExpandedItem from './ExpandedItem';

const Policies = ({ policy, idx, sortable, resources, canEdit, order, originalOrder }) => {
  return (
    <PolicyWrapper data-id={policy.id} key={policy.id} sortable={sortable}>
      <PolicyFilter
        policy={policy}
        data-id={policy.id}
        rowIndex={idx + 1}
        index={policy.index}
        sortable={sortable}
        idx={idx}
        order={order}
        originalOrder={originalOrder}
      />
      <ExpandedItem policy={policy} sortable={sortable} resources={resources} canEdit={canEdit} />
    </PolicyWrapper>
  );
};

export default Policies;
